// src/components/AboutPage.js
import React, { useEffect, useState, useRef, useContext } from 'react';
import './AboutPage.css';
import { LanguageContext } from '../translations/LanguageContext';

const MOUNTAIN_BG_WIDTH = 1440;
const MOUNTAIN_BG_HEIGHT = 749;
const MOUNTAIN_MAIN_HEIGHT = 712;
const MOUNTAIN_MAIN_OFFSET_Y = MOUNTAIN_BG_HEIGHT - MOUNTAIN_MAIN_HEIGHT - 35;

// Points are traced from the original PNG silhouettes for a scalable SVG.
const MOUNTAIN_BG_POINTS = {
  far: `0,749 8,749 16,749 24,749 32,749 40,749 48,749 56,749 64,749 72,749 80,749 88,749 96,749 104,749 112,749 120,749 128,749 136,749 144,749 152,749 160,749 168,749 176,749 184,749 192,749 200,749 208,749 216,749 224,749 232,749 240,749 248,749 256,749 264,749 272,749 280,749 288,749 296,749 304,749 312,749 320,749 328,749 336,749 344,749 352,749 360,749 368,749 376,749 384,749 392,749 400,749 408,749 416,749 424,749 432,749 440,749 448,749 456,749 464,749 472,749 480,749 488,749 496,749 504,749 512,749 520,749 528,749 536,749 544,749 552,749 560,749 568,749 576,749 584,749 592,749 600,749 608,749 616,749 624,749 632,749 640,749 648,749 656,749 664,749 672,749 680,749 688,749 696,749 704,749 712,749 720,88 728,87 736,82 744,77 752,72 760,67 768,62 776,60 784,61 792,62 800,63 808,64 816,65 824,65 832,65 840,65 848,65 856,65 864,63 872,62 880,60 888,57 896,53 904,48 912,44 920,38 928,33 936,27 944,27 952,27 960,27 968,27 976,23 984,18 992,12 1000,7 1008,1 1016,1 1024,3 1032,5 1040,6 1048,8 1056,10 1064,11 1072,13 1080,15 1088,16 1096,18 1104,20 1112,21 1120,23 1128,25 1136,26 1144,30 1152,34 1160,38 1168,42 1176,47 1184,51 1192,55 1200,59 1208,63 1216,68 1224,72 1232,76 1240,80 1248,84 1256,88 1264,93 1272,97 1280,99 1288,100 1296,102 1304,103 1312,105 1320,106 1328,108 1336,109 1344,111 1352,113 1360,114 1368,116 1376,117 1384,119 1392,120 1400,122 1408,123 1416,122 1424,120 1432,118`,
  mid: `0,158 8,157 16,155 24,154 32,152 40,150 48,148 56,147 64,145 72,143 80,141 88,138 96,136 104,134 112,131 120,129 128,126 136,123 144,120 152,116 160,112 168,108 176,104 184,100 192,96 200,92 208,88 216,84 224,80 232,76 240,73 248,69 256,66 264,63 272,60 280,57 288,55 296,53 304,52 312,53 320,57 328,75 336,101 344,100 352,100 360,104 368,116 376,117 384,116 392,115 400,112 408,107 416,103 424,99 432,94 440,90 448,85 456,81 464,77 472,72 480,68 488,63 496,59 504,55 512,50 520,46 528,41 536,37 544,33 552,32 560,33 568,34 576,33 584,32 592,29 600,24 608,16 616,7 624,2 632,10 640,19 648,29 656,38 664,47 672,57 680,66 688,73 696,77 704,81 712,86 720,90 728,94 736,98 744,102 752,107 760,111 768,115 776,119 784,123 792,127 800,131 808,135 816,139 824,143 832,147 840,152 848,156 856,160 864,164 872,168 880,172 888,176 896,180 904,184 912,188 920,192 928,197 936,201 944,204 952,207 960,210 968,213 976,216 984,219 992,222 1000,225 1008,228 1016,231 1024,234 1032,237 1040,240 1048,244 1056,247 1064,250 1072,253 1080,256 1088,259 1096,262 1104,265 1112,268 1120,271 1128,274 1136,277 1144,280 1152,283 1160,287 1168,290 1176,293 1184,296 1192,299 1200,302 1208,305 1216,308 1224,311 1232,314 1240,317 1248,320 1256,323 1264,326 1272,329 1280,333 1288,336 1296,339 1304,342 1312,345 1320,348 1328,351 1336,354 1344,357 1352,360 1360,363 1368,366 1376,369 1384,372 1392,376 1400,379 1408,382 1416,385 1424,388 1432,391`,
  near: `0,187 8,187 16,187 24,187 32,187 40,187 48,187 56,187 64,187 72,187 80,187 88,187 96,187 104,188 112,193 120,198 128,203 136,208 144,213 152,218 160,223 168,228 176,233 184,238 192,243 200,247 208,246 216,245 224,244 232,243 240,242 248,241 256,240 264,240 272,242 280,245 288,247 296,249 304,251 312,254 320,256 328,258 336,260 344,263 352,265 360,267 368,265 376,262 384,259 392,255 400,252 408,249 416,250 424,255 432,259 440,264 448,268 456,270 464,273 472,275 480,278 488,280 496,283 504,285 512,288 520,290 528,293 536,295 544,298 552,300 560,303 568,308 576,314 584,319 592,324 600,330 608,335 616,341 624,346 632,347 640,348 648,349 656,350 664,351 672,352 680,353 688,355 696,356 704,357 712,358 720,359 728,360 736,361 744,362 752,363 760,364 768,366 776,367 784,368 792,369 800,370 808,371 816,372 824,373 832,374 840,379 848,391 856,403 864,415 872,427 880,439 888,450 896,462 904,474 912,486 920,498 928,510 936,522 944,534 952,546 960,558 968,569 976,581 984,593 992,605 1000,617 1008,629 1016,641 1024,653 1032,665 1040,677 1048,689 1056,700 1064,712 1072,724 1080,724 1088,724 1096,724 1104,724 1112,724 1120,724 1128,724 1136,724 1144,724 1152,724 1160,724 1168,724 1176,724 1184,724 1192,724 1200,724 1208,724 1216,724 1224,724 1232,724 1240,724 1248,724 1256,724 1264,724 1272,724 1280,724 1288,724 1296,724 1304,724 1312,724 1320,724 1328,724 1336,724 1344,724 1352,724 1360,724 1368,724 1376,724 1384,724 1392,724 1400,724 1408,724 1416,724 1424,724 1432,724`,
};

const MOUNTAIN_MAIN_POINTS = `0,542 8,534 16,527 24,520 32,513 40,508 48,502 56,498 64,494 72,490 80,488 88,485 96,484 104,482 112,481 120,480 128,479 136,478 144,477 152,476 160,475 168,473 176,471 184,470 192,467 200,465 208,463 216,460 224,457 232,454 240,451 248,448 256,444 264,441 272,438 280,435 288,433 296,430 304,428 312,428 320,428 328,429 336,429 344,429 352,429 360,430 368,430 376,429 384,427 392,424 400,421 408,417 416,412 424,407 432,402 440,396 448,390 456,387 464,388 472,389 480,390 488,390 496,390 504,388 512,385 520,381 528,374 536,367 544,358 552,354 560,354 568,354 576,351 584,344 592,337 600,329 608,321 616,313 624,305 632,298 640,291 648,284 656,278 664,272 672,266 680,261 688,256 696,251 704,247 712,243 720,239 728,236 736,234 744,232 752,231 760,230 768,230 776,230 784,230 792,230 800,230 808,231 816,231 824,231 832,231 840,231 848,231 856,231 864,231 872,230 880,226 888,223 896,219 904,215 912,211 920,206 928,200 936,194 944,187 952,156 960,149 968,142 976,135 984,128 992,122 1000,115 1008,108 1016,95 1024,83 1032,73 1040,64 1048,56 1056,47 1064,38 1072,29 1080,21 1088,14 1096,7 1104,2 1112,0 1120,1 1128,7 1136,11 1144,15 1152,18 1160,21 1168,23 1176,24 1184,25 1192,28 1200,34 1208,40 1216,46 1224,52 1232,58 1240,64 1248,72 1256,83 1264,95 1272,106 1280,118 1288,130 1296,141 1304,153 1312,160 1320,167 1328,175 1336,182 1344,188 1352,193 1360,197 1368,201 1376,206 1384,210 1392,214 1400,218 1408,223 1416,234 1424,244 1432,255`;

const MOUNTAIN_BG_POLY_POINTS = {
  far: `${MOUNTAIN_BG_POINTS.far} ${MOUNTAIN_BG_WIDTH},${MOUNTAIN_BG_HEIGHT} 0,${MOUNTAIN_BG_HEIGHT}`,
  mid: `${MOUNTAIN_BG_POINTS.mid} ${MOUNTAIN_BG_WIDTH},${MOUNTAIN_BG_HEIGHT} 0,${MOUNTAIN_BG_HEIGHT}`,
  near: `${MOUNTAIN_BG_POINTS.near} ${MOUNTAIN_BG_WIDTH},${MOUNTAIN_BG_HEIGHT} 0,${MOUNTAIN_BG_HEIGHT}`,
};

const MOUNTAIN_MAIN_POLY_POINTS = `${MOUNTAIN_MAIN_POINTS} ${MOUNTAIN_BG_WIDTH},${MOUNTAIN_MAIN_HEIGHT} 0,${MOUNTAIN_MAIN_HEIGHT}`;

const MountainSceneSvg = ({ palette }) => (
  <svg
    className="mountain-svg"
    viewBox={`0 0 ${MOUNTAIN_BG_WIDTH} ${MOUNTAIN_BG_HEIGHT}`}
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    <polygon points={MOUNTAIN_BG_POLY_POINTS.far} fill={palette.far} />
    <polygon points={MOUNTAIN_BG_POLY_POINTS.mid} fill={palette.mid} />
    <polygon points={MOUNTAIN_BG_POLY_POINTS.near} fill={palette.near} />
    <g transform={`translate(0 ${MOUNTAIN_MAIN_OFFSET_Y})`}>
      <polygon points={MOUNTAIN_MAIN_POLY_POINTS} fill={palette.main} />
    </g>
  </svg>
);

function AboutPage() {
  const { language, translations } = useContext(LanguageContext);

  // Steps: 0=Welcome, 1=Skills, 2=Education, 3=Experience
  const totalSteps = 4;
  const [step, setStep] = useState(0);
  const [animationClass, setAnimationClass] = useState('fade-in');

  // For typewriter effect on "About me." title
  const [displayedTitle, setDisplayedTitle] = useState('');
  const titleText = translations[language].aboutPage?.title || 'About me.';
  const titleTimeoutRef = useRef(null);
  const restartTimeoutRef = useRef(null);
  const titleIndexRef = useRef(0);
  
  const typingSpeed = 100;
  const totalAnimationDuration = 14000; // 14 seconds total cycle time

  // To prevent multiple animations at once
  const isAnimatingRef = useRef(false);

  // For toggling images during the climbing animation
  const [imageToggle, setImageToggle] = useState(0);
  const imageToggleIntervalRef = useRef(null);

  // Get the translated step data
  const stepsData = translations[language].aboutPage.stepsData;

  // Position of the climbing figure (per step)
  const squarePositions = [
    { top: '62%', left: '11%' },   // step 0
    { top: '50%', left: '32%' },   // step 1
    { top: '27.5%', left: '58%' }, // step 2
    { top: '-4%', left: '78%' },   // step 3
  ];

  // Mountain palettes (per step)
  const mountainPalettes = [
    { far: '#A8AB6D', mid: '#8D9040', near: '#7D7A3C', main: '#595842' },
    { far: '#DCCFC4', mid: '#BAAEA4', near: '#9B8D81', main: '#776A5F' },
    { far: '#C3CAD2', mid: '#8192A3', near: '#5B6B7B', main: '#47535F' },
    { far: '#C2D3D5', mid: '#97B1B5', near: '#6C959A', main: '#5E8489' },
  ];

  const aboutRef = useRef(null);
  const touchStartRef = useRef(null);
  const touchEndRef = useRef(null);

  // Highlight function for step 0 & step 2 text:
  // - "passionate developer" (EN) / "leidenschaftlicher Entwickler" (DE)
  // - "Computer Science and Design" (EN) / "Informatik und Design" (DE) on its own line
  const highlightText = (text) => {
    let replaced = text;

    if (language === 'en') {
      replaced = replaced.replace(
        'passionate developer',
        `<span class="highlight">passionate developer</span>`
      );
      replaced = replaced.replace(
        'Computer Science and Design',
        `<br /><span class="highlight">Computer Science and Design</span><br />`
      );
    } else if (language === 'de') {
      replaced = replaced.replace(
        'leidenschaftlicher Entwickler',
        `<span class="highlight">leidenschaftlicher Entwickler</span>`
      );
      replaced = replaced.replace(
        'Informatik und Design',
        `<br /><span class="highlight">Informatik und Design</span><br />`
      );
    }

    // Convert any '\n' in the source text to <br>
    replaced = replaced.replace(/\n/g, '<br />');
    return replaced;
  };

  useEffect(() => {
    // Hide the body scrollbar while on AboutPage
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Wheel / mouse scroll
    const handleWheel = (e) => {
      if (aboutRef.current && aboutRef.current.contains(e.target)) {
        e.preventDefault();
        if (!isAnimatingRef.current) {
          isAnimatingRef.current = true;
          if (e.deltaY > 0) {
            changeStep(step + 1);
          } else {
            changeStep(step - 1);
          }
        }
      }
    };

    // Touchstart/touchend for mobile
    const handleTouchStart = (e) => {
      touchStartRef.current = e.changedTouches[0].clientY;
    };

    const handleTouchEnd = (e) => {
      touchEndRef.current = e.changedTouches[0].clientY;
      handleGesture();
    };

    const handleGesture = () => {
      if (!touchStartRef.current || !touchEndRef.current || isAnimatingRef.current) return;
      const deltaY = touchStartRef.current - touchEndRef.current;
      const threshold = 50; // Minimum swipe distance
      if (Math.abs(deltaY) > threshold) {
        if (deltaY > 0) {
          // swipe up → next step
          changeStep(step + 1);
        } else {
          // swipe down → previous step
          changeStep(step - 1);
        }
      }
      // Reset
      touchStartRef.current = null;
      touchEndRef.current = null;
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('touchstart', handleTouchStart, { passive: false });
    window.addEventListener('touchend', handleTouchEnd, { passive: false });

    return () => {
      // Restore the original overflow
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
      if (imageToggleIntervalRef.current) {
        clearInterval(imageToggleIntervalRef.current);
      }
    };
  }, [step, language]);

  // Add typewriter effect for the title text
  useEffect(() => {
    let isCancelled = false;

    // Reset title text when language changes
    setDisplayedTitle('');
    titleIndexRef.current = 0;
    
    // Clear any existing timeouts
    if (titleTimeoutRef.current) clearTimeout(titleTimeoutRef.current);
    if (restartTimeoutRef.current) clearTimeout(restartTimeoutRef.current);
    
    const typeTitle = () => {
      if (isCancelled) return;

      if (titleIndexRef.current < titleText.length) {
        const nextChar = titleText[titleIndexRef.current];
        setDisplayedTitle(prev => prev + nextChar);
        titleIndexRef.current++;
        titleTimeoutRef.current = setTimeout(typeTitle, typingSpeed);
      } else {
        // Calculate how long to wait before restarting
        // Total cycle time minus the time it took to type
        const typingDuration = titleText.length * typingSpeed;
        const remainingTime = totalAnimationDuration - typingDuration;
        
        if (remainingTime > 0) {
          restartTimeoutRef.current = setTimeout(restartTyping, remainingTime);
        } else {
          restartTyping();
        }
      }
    };
    
    const restartTyping = () => {
      if (isCancelled) return;
      setDisplayedTitle('');
      titleIndexRef.current = 0;
      titleTimeoutRef.current = setTimeout(typeTitle, typingSpeed);
    };
    
    // Start the typing animation
    titleTimeoutRef.current = setTimeout(typeTitle, 500);
    
    return () => {
      isCancelled = true;
      if (titleTimeoutRef.current) clearTimeout(titleTimeoutRef.current);
      if (restartTimeoutRef.current) clearTimeout(restartTimeoutRef.current);
    };
  }, [language, titleText, typingSpeed, totalAnimationDuration]);

  const changeStep = (newStep) => {
    if (newStep < 0 || newStep >= totalSteps) {
      isAnimatingRef.current = false;
      return;
    }
    setAnimationClass('fade-out');

    // Start toggling images for the walking/climbing figure
    imageToggleIntervalRef.current = setInterval(() => {
      setImageToggle((prev) => (prev === 0 ? 1 : 0));
    }, 250);

    // After fade-out animation
    setTimeout(() => {
      setStep(newStep);
      setAnimationClass('fade-in');

      // Stop toggling
      if (imageToggleIntervalRef.current) {
        clearInterval(imageToggleIntervalRef.current);
        imageToggleIntervalRef.current = null;
      }
      setImageToggle(0);

      // Re-enable animation after fade-in finishes
      setTimeout(() => {
        isAnimatingRef.current = false;
      }, 500);
    }, 500);
  };

  // Current step's data
  const { bigHeading, paragraphs, skills } = stepsData[step];
  const { top, left } = squarePositions[step];
  const palette = mountainPalettes[step];

  // Determine climbing vs summit image
  const climbingSquareSrc =
    step === 3
      ? '/AboutPage/summitMe.png'
      : imageToggle === 0
      ? '/AboutPage/climbingMe.png'
      : '/AboutPage/climbingMe2.png';

  const climbingSquareAlt =
    step === 3
      ? 'Summit Me'
      : imageToggle === 0
      ? 'Climbing Me 1'
      : 'Climbing Me 2';

  return (
    <section className="about-section" ref={aboutRef}>
      {/* Mountain scene (vector) */}
      <div className="mountain-scene" aria-hidden="true">
        <MountainSceneSvg palette={palette} />
        <img
          className="climbing-square"
          src={climbingSquareSrc}
          alt={climbingSquareAlt}
          style={{ top, left }}
        />
      </div>

      {/* The top title "About me." with typewriter effect */}
      <h1 className="about-title">
        {displayedTitle}
        {displayedTitle.length < titleText.length && <span className="cursor"></span>}
      </h1>

      {/* Animated Content */}
      <div className={`animated-content ${animationClass}`}>
        {/* Large heading (Welcome!, Skills, Education, Experience) */}
        <h2 className="bottom-left-heading">{bigHeading}</h2>

        {/* Paragraph text, with highlights for step 0 & step 2 */}
        {paragraphs && paragraphs.length > 0 && (
          <div className="step-content">
            {paragraphs.map((p, i) => (
              <p
                key={i}
                dangerouslySetInnerHTML={{
                  __html: highlightText(p),
                }}
              />
            ))}
          </div>
        )}

        {/* Skills listing (step 1) */}
        {skills && skills.length > 0 && (
          <div className="skills-container">
            <ul className="skills-list">
              {skills.map((skill, idx) => (
                <li key={idx}>{skill}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}

export default AboutPage;
